<style lang="scss">
.skill {
  border: 1px solid $c-dark-grey;
  display: flex;
  width: 100%;
  align-items: center;

  .text {
    //font-size: 90%;
    display: flex;
    align-self: center;

    flex-grow: 1;
    width: 0%;
    & > span {
      display: inline-block;

      position: relative;
      width: 100%;
      padding: 10px;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    //

    //
  }
  text-transform: uppercase;
  text-align: left;
  position: relative;
  svg {
    fill: $c-dark-blue;
  }
  .smdtooltip {
    transform: translateY(-7px);
  }

  .icons {
    display: flex;
    align-items: center;
    padding-left: 6px;
  }
}
</style>

<template>
  <div class="skill" :class="{ strategic: isStrategic, future: isFuture, leadership: skill.leadership }">
    <div class="icons">
      <Icon :path="mdiStar" :width="30" :height="30" v-if="isStrategic" class="strategic" />
      <Icon :path="mdiDiamond" :width="30" :height="30" v-if="isFuture" class="future" />
      <Icon :path="mdiCrown" :width="30" :height="30" v-if="skill.leadership" class="leadership" />
    </div>
    <Tooltip v-if="skill.description && skill.description != ''" :text="skill.name.toUpperCase()">
      <p>
        <b>{{ skill.name }}</b>
      </p>
      <p>{{ skill.description }}</p>
    </Tooltip>
    <div class="text" v-else>
      <span>{{ skill.name }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mdiStar, mdiDiamond, mdiCrown } from '@mdi/js';

export default defineComponent({
  props: {
    skill: { type: Object, required: true },
    isFuture: { type: Boolean, default: false },
    isStrategic: { type: Boolean, default: false },
  },
  setup() {
    return {
      mdiStar,
      mdiDiamond,
      mdiCrown,
    };
  },
});
</script>
